import { defineStore } from "pinia";
import { ref } from "vue";

export const useEnvironmentStore = defineStore("environment", () => {
    const api = ref<string>();
    const assets = ref<string>();

    function inject(apiEndpoint: string, assetsEndpoint: string) {
        api.value = apiEndpoint;
        assets.value = assetsEndpoint;
    }

    return { api, assets, inject };
});
